export enum NOTIFICATION_TYPES {
  DEFAULT = 'default',
  ALERT = 'alert',
  ERROR = 'error',
  SUCCESS = 'success',
  INFO = 'info',
}
